'use strict';

const getScriptUrl = (apiKey) => {
  return `//maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
};
const googleMapsLoader = [
  '$q',
  '$window',
  'jsLoader',
  'config',

  function ($q, $window, jsLoader, config) {
    var googleMaps;
    var googleMapsPromise;

    function errorHandler(reject) {
      googleMapsPromise = null;
      reject();
    }

    function fetchGoogleMaps() {

      // if googleMapsPromise is falsy, start loading
      if (!googleMapsPromise) {
        const url = getScriptUrl(config.googleApiKey);
        googleMapsPromise = new $q((resolve, reject) => {
          jsLoader(url, 'google')
            .then(function (google) {
              googleMaps = google.maps;

              // check if Google Maps script loaded successfully
              if (googleMaps) {
                resolve(googleMaps);
              } else {
                errorHandler(reject);
              }
            })
            .catch(() => {
              errorHandler(reject);
            });
        });
      }

      return googleMapsPromise;
    }

    return function () {
      return googleMaps ? $q.resolve(googleMaps) : fetchGoogleMaps();
    };
  }
];

export default googleMapsLoader;



// WEBPACK FOOTER //
// ./app/src/services/google_maps_loader.js